import classNames from 'classnames'
import { CollectionContents_contents_edges_node, Visibility } from 'globalTypes'

import RootLink from 'Root/Component/Link'

import styles from './index.module.css'

type CollectionContent = CollectionContents_contents_edges_node & {
  __typename: string
  canReadCollection?: boolean
  canManageCollection?: boolean
  collectionSlug?: string
}

interface Props {
  className?: string
  customStyle?: Object
  children: React.ReactNode | React.ReactNode[]
  content: CollectionContent
  collectionVisibility: string
  collectionNeedRegistration?: boolean
}

const canAccessToContent = (
  content,
  collectionVisibility,
  collectionNeedRegistration
) => {
  if (
    (collectionVisibility == Visibility.public &&
      content.visibilityForCollection == Visibility.protected &&
      content.canReadCollection == false) ||
    (collectionNeedRegistration && !content.canReadCollection)
  ) {
    return false
  }

  return true
}

const Link = ({
  className,
  customStyle,
  children,
  content,
  collectionVisibility,
  collectionNeedRegistration,
}: Props) => {
  // Note: This should be done in a shared component between collections and contents
  // that can have other linked contents inside(e.g. Events)
  const pathToContent = content.collectionSlug
    ? `/cc/${content.collectionSlug}/${content.slug}`
    : `/c/${content.slug}`

  if (
    canAccessToContent(
      content,
      collectionVisibility,
      collectionNeedRegistration
    )
  ) {
    return (
      <RootLink
        className={classNames(className, styles.link)}
        to={pathToContent}
        style={customStyle}
      >
        {children}
      </RootLink>
    )
  }

  return (
    <span
      className={classNames(
        className,
        'pointer-events-none opacity-50',
        styles.link
      )}
    >
      {children}
    </span>
  )
}

export default Link
